import { DEFAULT_TEXT_COLOR, TextStyle } from 'src/model';

export type CanvasTextStyle = {
    x?: number,
    y?: number,
    blur?: number,
    color?: string,
    shadowColor?: string,
    lineWidth?: number,
    lineColor?: string,
};

export const prepareStyle = ({
    // lightFooter,
    lightHeader,
    requireShadow,
    effectTextStyle,
    pendulumTextStyle,
    otherTextStyle,
    statTextStyle,
    typeTextStyle,
}: {
    requireShadow: boolean,
    lightHeader: boolean,
    lightFooter: boolean,
    effectTextStyle: TextStyle,
    pendulumTextStyle: TextStyle,
    otherTextStyle: TextStyle,
    statTextStyle: TextStyle,
    typeTextStyle: TextStyle,
}) => {
    // Normalize text styles - convert objects with numeric keys to proper arrays
    const normalizeTextStyle = (style: any): TextStyle => {
        if (!style) return [false, DEFAULT_TEXT_COLOR, false, '#000000'];
        if (Array.isArray(style)) return style as TextStyle;
        // Convert object with numeric keys to array
        if (typeof style === 'object' && '0' in style) {
            return [style[0], style[1], style[2], style[3]] as TextStyle;
        }
        return [false, DEFAULT_TEXT_COLOR, false, '#000000'];
    };

    const normalizedEffectTextStyle = normalizeTextStyle(effectTextStyle);
    const normalizedPendulumTextStyle = normalizeTextStyle(pendulumTextStyle);
    const normalizedOtherTextStyle = normalizeTextStyle(otherTextStyle);
    const normalizedStatTextStyle = normalizeTextStyle(statTextStyle);
    const normalizedTypeTextStyle = normalizeTextStyle(typeTextStyle);

    const levelColor = { color: lightHeader ? '#ffffff' : DEFAULT_TEXT_COLOR };
    const levelStyle = requireShadow
        ? {
            blur: 2,
            y: 1,
            shadowColor: lightHeader ? '#000000' : '#ffffff',
            ...levelColor,
        }
        : levelColor;

    const [customEffectText, effectTextFillStyle, effectHasShadow, effectTextShadow] = normalizedEffectTextStyle;
    const resolvedEffectTextStyle: CanvasTextStyle = customEffectText
        ? {
            ...(effectHasShadow ? { y: 0, blur: 4, shadowColor: effectTextShadow } : {}),
            color: effectTextFillStyle,
        }
        : {};

    const [customPendulumEffectText, pendulumEffectTextFillStyle, pendulumEffectHasShadow, pendulumEffectTextShadow] = normalizedPendulumTextStyle;
    const resolvedPendulumEffectTextStyle: CanvasTextStyle = customPendulumEffectText
        ? {
            ...(pendulumEffectHasShadow ? { y: 0, blur: 4, shadowColor: pendulumEffectTextShadow } : {}),
            color: pendulumEffectTextFillStyle,
        }
        : {};

    const [customTypeText, typeTextFillStyle, typeHasShadow, typeTextShadow] = normalizedTypeTextStyle;
    const resolvedTypeTextStyle: CanvasTextStyle = customTypeText
        ? {
            ...(typeHasShadow ? { y: 1, blur: 1, shadowColor: typeTextShadow } : {}),
            color: typeTextFillStyle,
        }
        : {};

    const [customStatText, statTextFillStyle, statHasShadow, statTextShadow] = normalizedStatTextStyle;
    const resolvedStatTextStyle: CanvasTextStyle = customStatText
        ? {
            ...(statHasShadow ? { y: 1, blur: 1, shadowColor: statTextShadow } : {}),
            color: statTextFillStyle,
        }
        : {};

    const [customOtherEffectText, otherEffectTextFillStyle, otherEffectHasShadow, otherEffectTextShadow] = normalizedOtherTextStyle;
    const resolvedOtherEffectTextStyle: CanvasTextStyle = customOtherEffectText
        ? {
            ...(otherEffectHasShadow ? { y: 0, blur: 0, shadowColor: otherEffectTextShadow } : {}),
            color: otherEffectTextFillStyle,
        }
        : {};

    return {
        levelStyle,
        resolvedEffectTextStyle,
        resolvedOtherEffectTextStyle,
        resolvedPendulumEffectTextStyle,
        resolvedStatTextStyle,
        resolvedTypeTextStyle,
    };
};